import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useChecklistServicoEmpreendimentoFilters
 */

type State = {
    idEmpreendimento: number;
    idsChecklistServico: number[];
    idsBlocos: number[];
    idsUnidades: number[];
    idsItemServicoEmpreendimento: number[];
};

type Action = {
    setIdEmpreendimento: (idEmpreendimento: number) => void,
    setIdsChecklistServico: (idsChecklistServico: number[]) => void,
    setIdsBlocos: (idsBlocos: number[]) => void,
    setIdsUnidades: (idsUnidades: number[]) => void,
    setIdsItemServicoEmpreendimento: (idsItemServicoEmpreendimento: number[]) => void,
};

export const useChecklistServicoEmpreendimentoFilters = create<State & Action>((set) => ({
    idEmpreendimento: 0,
    idsChecklistServico: [],
    idsBlocos: [],
    idsUnidades: [],
    idsItemServicoEmpreendimento: [],
    setIdEmpreendimento: (idEmpreendimento) => set({ idEmpreendimento }),
    setIdsChecklistServico: (idsChecklistServico) => set({ idsChecklistServico }),
    setIdsBlocos: (idsBlocos) => set({ idsBlocos }),
    setIdsUnidades: (idsUnidades) => set({ idsUnidades }),
    setIdsItemServicoEmpreendimento: (idsItemServicoEmpreendimento) => set({ idsItemServicoEmpreendimento }),

}));